module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-BlackItalic.f60d7edd.ttf";